"use client"

import { styled, Typography } from "@mui/material"
import { extractProperty, replaceRichTextLinks } from "utils"

const StyledText = styled(Typography)<{ component: any }>`
  a {
    word-break: break-all;
  }
  table {
    max-width: 100%;
    overflow-x: auto;
    display: flex;
  }
`

type Props = {
  data: any
}

const TitleTextAndMedia = ({ data }: Props) => {
  const subTitle = extractProperty(data, "subTitle")
  const content = extractProperty(data, "content")
  return (
    <>
      <Typography variant="h2">{subTitle}</Typography>
      <StyledText
        variant="body1"
        component={"div"}
        dangerouslySetInnerHTML={{
          __html: replaceRichTextLinks(content)?.replace("h2", "h3"),
        }}
      />
    </>
  )
}

export default TitleTextAndMedia
